import React from 'react';
import { Button } from 'reactstrap';
import { ColorPickerComponent } from '@syncfusion/ej2-react-inputs';
import i18n from 'i18next';

import CloseIcon from '../../../assets/icons/lexon/close-sm.svg?react';
import CloseRoundIcon from '../../../assets/icons/close-round.svg?react';

function EventTypeDialogForm({
  title,
  submitText,
  nameValue,
  errorName,
  color,
  paletteColors,
  paletteColumns,
  canSubmit,
  colorPickerRef,
  onNameChange,
  onClearName,
  onBeforeTileRender,
  onColorChange,
  onCancel,
  onSubmit
}) {
  return (
    <div className="event-type-dialog-form">
      <div className="event-type-dialog-form__header">
        <span className="inter-semibold-14 text-color-blue-900">{title}</span>
        <button
          className="event-type-dialog-form__close"
          onClick={onCancel}
          aria-label={i18n.t('general.close')}
          type="button"
        >
          <CloseIcon width={12.375} height={12.375} />
        </button>
      </div>
      <div className="event-type-dialog-form__body">
        <div className="event-type-dialog-form__name">
          <label className="inter-regular-14 text-color-grey-800 event-type-dialog-form__label">
            {i18n.t('eventtype.name')}<span className="inter-bold-14 text-required ml-1">*</span>
          </label>
          <div className={`event-type-name-field${errorName ? ' event-type-name-field--error' : ''}`}>
            <input
              autoFocus
              type="text"
              className="event-type-name-input"
              placeholder={i18n.t('eventtype.name_placeholder')}
              value={nameValue}
              onChange={(e) => onNameChange(e.target.value)}
            />
            {nameValue && (
              <button
                type="button"
                className="event-type-name-clear"
                onClick={onClearName}
                tabIndex={-1}
                aria-label="Limpiar"
              >
                <CloseRoundIcon width={13} height={13} />
              </button>
            )}
          </div>
          {errorName && (
            <div className="errormessage event-type-dialog-form__error">{errorName}</div>
          )}
        </div>
        <div className="event-type-dialog-form__color">
          <label className="inter-regular-14 text-color-grey-800 event-type-dialog-form__label">
            {i18n.t('eventtype.color')}<span className="inter-bold-14 text-required ml-1">*</span>
          </label>
          <div className="e-rounded-wrap e-rounded-wrap-horizontal">
            <ColorPickerComponent
              id="rounded-palette"
              value={color}
              mode="Palette"
              ref={colorPickerRef}
              modeSwitcher={false}
              inline={true}
              showButtons={false}
              columns={paletteColumns}
              presetColors={{ custom1: paletteColors }}
              beforeTileRender={onBeforeTileRender}
              change={onColorChange}
            />
          </div>
        </div>
      </div>
      <div className="event-type-dialog-form__footer btn-action-container">
        <Button
          color="link"
          className="inter-regular-14 event-type-cancel-link"
          onClick={onCancel}
        >
          {i18n.t('eventtype.cancel')}
        </Button>
        <Button
          color="secondary"
          className="btn-outline-primary inter-bold-14"
          disabled={!canSubmit}
          title={submitText}
          onClick={onSubmit}
        >
          {submitText}
        </Button>
      </div>
    </div>
  );
}

export default EventTypeDialogForm;
